import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './educationCategories.style';
import { CustomButton, CustomToast, ActionEditIcon, CustomTable } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IEducationCategories } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from "../../../../components/CustomTable/customTable";

const EducationCategories = () => {
    const [educationCategories, setEducationCategories] = useState<IEducationCategories[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentEducationCategories, setCurrentEducationCategories] = useState({ id: 0, educationName: '' });
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    useEffect(() => {
        loadGroup();
    }, []);

    const loadGroup = async () => {
        const response = await fetchApi<IEducationCategories[]>("Hrlense_EducationCategories", "GET");
        if (response) setEducationCategories(response);
    };

    const handleAddNewEducation = () => {
        setIsEditMode(false);
        setCurrentEducationCategories({ id: 0, educationName: '' });
        setDrawerOpen(true);
    };

    const handleEditEducation = (educationCategories: IEducationCategories) => {
        setIsEditMode(true);
        setSelectedId(educationCategories.id);
        setCurrentEducationCategories(educationCategories);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setCurrentEducationCategories(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!currentEducationCategories.educationName.trim()) {
            addToast({ message: "Please enter Education Name ", status: "warning" });
            return;
        }
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_EducationCategories/${currentEducationCategories.id}`, "PUT", { id: currentEducationCategories.id, educationName: currentEducationCategories.educationName, }, null, "Education updated successfully");

            if (response) setEducationCategories((prev) => prev.map((educationCategories) => (educationCategories.id === selectedId ? currentEducationCategories : educationCategories)));
        } else {
            const response = await fetchApi<IEducationCategories>("Hrlense_EducationCategories", "POST", { educationName: currentEducationCategories.educationName, }, null, "Education added successfully");
            if (response) setEducationCategories((prev) => [...prev, response]);
        }
        setDrawerOpen(false);
    };

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>) : (
                    <>
                        <Flex className="page_heading flex_header" >
                            <Text className="font-poppins text_semibold text_3xl">Education Category </Text>
                            <Flex gap={2}>
                                <CustomButton title="Add New Education Category" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewEducation} />
                            </Flex>
                        </Flex>
                        <Grid className='grid_container'>
                            <GridItem colSpan={12}>
                                <CustomTable value={educationCategories} emptyMessage="No education categories found." >
                                    <Column header="S. No" body={(_, index) => index + 1} />
                                    <Column header="Education Name" field="educationName" />
                                    <Column header="Actions" body={(row: any) => (<ActionEditIcon onClick={() => handleEditEducation(row)} />)}/>
                                </CustomTable>
                            </GridItem> 
                        </Grid>

                        <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                            <DrawerOverlay />
                            <DrawerContent>
                                <DrawerCloseButton />
                                <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Education Category' : 'Add New Education Category'}</DrawerHeader>
                                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                                    <Box py={4}>
                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Education Name</FormLabel>
                                            <Input name="educationName" value={currentEducationCategories.educationName} onChange={handleInputChange} placeholder="Enter Education name" />
                                        </FormControl>
                                    </Box>
                                    <Flex justify="flex-end" mt={4} gap={2}>
                                        <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                                        <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Category" : "Add Category"}</Button>
                                    </Flex>
                                </DrawerBody>
                            </DrawerContent>
                        </Drawer>
                    </>)}
            </Box>
        </MyDiv>
    )
}

export default EducationCategories;
